<template>
    <div v-if="selectedLesson">
        <v-stepper v-model="currentQuestion">
            <v-stepper-header v-if="selectedLesson.test.questions.length <= 6 || !$vuetify.breakpoint.mobile">
                    <template v-for="(question, index) in selectedLesson.test.questions">
                        <v-stepper-step :complete="currentQuestion > index + 1" :step="index + 1" :key="'a' + index" />
                        <v-divider v-if="index < selectedLesson.test.questions.length - 1" :key="'b' + index" />
                    </template>
            </v-stepper-header>
            <v-stepper-header v-else>
                <template v-for="questionIndex in [1, 2]">
                    <v-stepper-step :complete="currentQuestion > questionIndex" :step="questionIndex" :key="'a' + questionIndex" />
                    <v-divider v-if="questionIndex < selectedLesson.test.questions.length - 1" :key="'b' + questionIndex" />
                </template>
                    <v-stepper-step
                        v-if="currentQuestion > 2 && currentQuestion <= selectedLesson.test.questions.length - 2"
                        :step="currentQuestion"
                        :class="{'active-question': currentQuestion > 2 && currentQuestion <= selectedLesson.test.questions.length - 2}"
                        :complete="currentQuestion > 8"
                    />
                    <v-stepper-step
                        v-else
                        :step="'...'"
                        :complete="currentQuestion > 8"
                    />
                    <v-divider />
                <template v-for="questionIndex in genRange(selectedLesson.test.questions.length + 1).splice(-2, 2)">
                    <v-stepper-step :complete="currentQuestion > questionIndex" :step="questionIndex" :key="'a' + questionIndex" />
                    <v-divider v-if="questionIndex < selectedLesson.test.questions.length" :key="'b' + questionIndex" />
                </template>
            </v-stepper-header>
            <v-stepper-items>
                <v-stepper-content v-for="(question, questionIndex) in selectedLesson.test.questions" :key="question._id" :step="questionIndex + 1">
                    <v-card>
                        <v-card-title :class="{'d-flex justify-center text-center': !$vuetify.breakpoint.mobile}">
                            {{ question.question }}
                        </v-card-title>
                        <v-divider />
                        <v-card-text>
                            <v-list>
                                <v-list-item-group :value="question.options.indexOf(answers[question._id])">
                                    <v-list-item
                                        v-for="option in question.options" :key="option._id"
                                        three-line
                                        @click="selectAnswer(question._id, option._id)"
                                    >
                                        <v-list-item-content :class="{'d-flex justify-center text-center': !$vuetify.breakpoint.mobile}">
                                            {{ option.option }}
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list-item-group>
                            </v-list>
                        </v-card-text>
                        <v-divider />
                        <v-card-actions v-if="currentQuestion > 1" class="mt-4" >
                            <v-btn
                                @click="currentQuestion -= 1"
                                text
                                outlined
                            >
                                <v-icon left>fa-arrow-left</v-icon>
                                Tilbage
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-stepper-content>
                <v-stepper-content :step="selectedLesson.test.questions.length + 1">
                    <loader v-if="loading" />
                    <v-card v-else>
                        <v-card-title class="text-center">
                            <v-row>
                                <v-col v-if="testResult.passed">Du bestod testen!</v-col>
                                <v-col v-else>Du bestod ikke testen.</v-col>
                            </v-row>
                        </v-card-title>
                        <v-card-text class="text-center">
                            <v-row>
                                <v-col>
                                    Du svarede rigtigt på {{ testResult.correctAnswersCount }}/{{ selectedLesson.test.questions.length }} spørgsmål.
                                </v-col>
                            </v-row>
                            <v-row v-if="!testResult.passed">
                                <v-col>
                                    Du skal svare rigtigt på min. {{ selectedLesson.test.minimumRequired }} spørgsmål for at bestå testen.
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-divider />
                        <v-card-actions class="text-center">
                            <v-row>
                                <v-col>
                                    <v-btn to="/user/training">
                                        <v-icon left>fa-arrow-left</v-icon>
                                        Tilbage til kursusoversigt
                                    </v-btn>
                                </v-col>
                                <v-col>
                                    <v-btn to="/video" class="mx-4 white--text" color="primary">
                                        <v-icon left>fa-eye</v-icon>
                                        Se video igen
                                    </v-btn>
                                </v-col>
                                <v-col>
                                    <v-btn @click="resetTest" class="white--text" color="primary">
                                        <v-icon left>fa-spell-check</v-icon>
                                        Tag test igen
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-card-actions>
                    </v-card>
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>
    </div>
    <loader v-else />
</template>

<script>

export default {
    data () {
        return {
            currentQuestion: 1,
            loading: true,
            answers: {},
            testResult: null
        }
    },
    computed: {
        selectedLesson () {
            return this.$store.state.training.selectedLesson
        },
        uniqueId () {
            return this.$store.state.main.uniqueId
        }
    },
    methods: {
        genRange (length) {
            return [...Array(length).keys()]
        },
        async checkAnswers () {
            const response = await this.$http().post(`user/${this.uniqueId}/training/lessons/${this.selectedLesson._id}/checkAnswers`, this.answers)
            if (response.status === 200) {
                this.testResult = response.data
                this.loading = false
            }
        },
        selectAnswer (questionId, optionId) {
            this.answers[questionId] = optionId
            if (this.currentQuestion === this.selectedLesson.test.questions.length) this.checkAnswers()
            this.currentQuestion++
        },
        resetTest () {
            this.currentQuestion = 1,
            this.loading = true,
            this.answers = {},
            this.testResult = null
        }
    },
    created () {
        if (!this.selectedLesson) this.$router.push({ name: 'UserTraining' })
    }
}
</script>

<style lang="scss">
.active-question {
    .v-stepper__step__step {
        background: #1976d2 !important;
        color: white !important;
    }
}
</style>